import React from 'react';

interface BestValueCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const BestValueCheckbox: React.FC<BestValueCheckboxProps> = ({ checked, onChange }) => {
  return (
    <div className="pt-[20px]">
      <label className="flex items-center cursor-pointer group gap-[12px] [text-transform:unset]">
        <div className="relative flex items-center">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            className="sr-only"
          />
          <div
            className={`w-[24px] h-[24px] bg-white shadow-lg border-2 rounded-[6px] flex items-center justify-center transition-all duration-200 ${
              checked ? 'border-[#EE731B]' : 'border-gray-300 group-hover:border-[#EE731B]'
            }`}
          >
            {checked && (
              <svg className="w-4 h-4 text-[#EE731B]" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </div>
        <p
          className={`text-[14px] leading-[22px] font-medium group-hover:text-[#EE731B] w-fit my-0 ${checked ? 'text-[#EE731B]' : 'text-gray-600'}`}
        >
          Add best value tag
        </p>
      </label>
    </div>
  );
};

export default BestValueCheckbox;
